var _a;
export var ALL = 'Összes feladat';
export var NORMAL = 'Normál feladatok';
export var OVERWORK = 'Túlórák';
var defaultFilter = function (_) { return true; };
var filters = (_a = {},
    _a[ALL] = defaultFilter,
    _a[NORMAL] = function (task) { return !task.overwork; },
    _a[OVERWORK] = function (task) { return task.overwork; },
    _a);
export function getTaskTypeOptions() {
    return [ALL, NORMAL, OVERWORK];
}
export function getTaskTypeFilter(type) {
    return filters[type] || defaultFilter;
}



//////////////////
// WEBPACK FOOTER
// ./src/models/TaskTypeOptions.ts
// module id = 198
// module chunks = 0